export function replaceInArray<D>(array: D[],
    predicate: ((item: D, index: number, arr: D[]) => boolean),
    replacer?: ((current: D) => D) | D,
    onNotFound?: () => void
): D[] {
    const indexOfItem = array.findIndex(predicate);
    if (indexOfItem >= 0) {
        const newArray = [...array];
        let newValue: D;
        if (typeof replacer === 'function') {
            newValue = (replacer as Function)(array[indexOfItem]);
        } else {
            newValue = replacer;
        }

        newArray[indexOfItem] = newValue;
        return newArray;
    } else {
        onNotFound();
    }

    return array;
}

export function upsertInArray<D>(array: D[] = [],
    predicate: ((item: D, index: number, arr: D[]) => boolean),
    replacer?: ((current?: D) => D) | D,
): D[] {
    const indexOfItem = array.findIndex(predicate);
    const newArray = [...array];
    if (indexOfItem >= 0) {
        const newValue = typeof replacer === 'function' ? (replacer as Function)(array[indexOfItem]) : replacer;
        newArray[indexOfItem] = newValue;
    } else {
        const newValue = typeof replacer === 'function' ? (replacer as Function)() : replacer;
        newArray.push(newValue);
    }
    return newArray;
}

export function replaceAllInArray<D>(array: D[],
    predicate: ((item: D, index: number, arr: D[]) => boolean),
    replacer?: ((current: D) => D)
): D[] {
    return array.map((item, index, arr) => {
        if (!predicate(item, index, arr)) return item;
        return replacer(item);
    });
}
